import { useRef } from 'react';

interface ImageUploaderProps {
  value: string;
  onChange: (url: string) => void;
  label?: string;
  placeholder?: string;
  previewWidth?: string;
  previewHeight?: string;
}

export default function ImageUploader({
  value,
  onChange,
  label,
  placeholder = 'https://...',
  previewWidth = 'w-36',
  previewHeight = 'h-24',
}: ImageUploaderProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const url = ev.target?.result as string;
      onChange(url);
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  };

  return (
    <div>
      {label && (
        <label className="text-xs text-gray-500 mb-1 block">{label}</label>
      )}
      <div className="flex gap-3 items-start">
        {/* 预览区 */}
        <div
          className={`${previewWidth} ${previewHeight} flex-shrink-0 rounded-lg overflow-hidden border border-gray-200 bg-gray-50 flex items-center justify-center cursor-pointer hover:border-teal-400 transition-colors`}
          onClick={() => fileInputRef.current?.click()}
          title="点击上传图片"
        >
          {value ? (
            <img
              src={value}
              alt="预览"
              className="w-full h-full object-cover object-top"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
          ) : (
            <div className="flex flex-col items-center text-gray-300 select-none">
              <i className="ri-image-add-line text-2xl mb-1"></i>
              <span className="text-xs">点击上传</span>
            </div>
          )}
        </div>

        {/* 输入区 */}
        <div className="flex-1 space-y-2">
          <input
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
          />
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => fileInputRef.current?.click()}
              className="flex items-center gap-1.5 text-xs text-teal-600 cursor-pointer hover:text-teal-700 whitespace-nowrap"
            >
              <i className="ri-upload-line"></i>
              <span>从本地上传</span>
            </button>
            {value && (
              <button
                type="button"
                onClick={() => onChange('')}
                className="flex items-center gap-1 text-xs text-rose-400 hover:text-rose-600 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-delete-bin-line"></i>清除图片
              </button>
            )}
          </div>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleFileChange}
          />
        </div>
      </div>
    </div>
  );
}
